import Navbar from "../Navbar/Navbar";
import UnderNavbar from "../sectionComponents/UnderNavbar";
import IconCardsComponent from "../sectionComponents/IconCardsComponent";
import NumberCardsComponent from "../sectionComponents/NumberCardsComponent";
import HomeFormComponent from "../sectionComponents/HomeFormComponent";
import Footer from "../Navbar/Footer";

import {
  ICON_CARD_SECTION_TITLE,
  ICON_CARD,
  NUMBER_CARD,
  NUMBER_CARD_SECTION_TEXT,
  NUMBER_CARD_SECTION_TITLE,
  UNDER_NAVBAR_COMPONENT_COLOR_TITLE,
  UNDER_NAVBAR_COMPONENT_TITLE,
  UNDER_NAVBAR_COMPONENT_TEXT
} from "../../constants/HomeConstants";

function Home() {
  return (
    <div>
      <Navbar />
      <UnderNavbar
        colorTitle={UNDER_NAVBAR_COMPONENT_COLOR_TITLE}
        title={UNDER_NAVBAR_COMPONENT_TITLE}
        text={UNDER_NAVBAR_COMPONENT_TEXT}
      />
      <IconCardsComponent
        iconCards={ICON_CARD}
        sectionTitle={ICON_CARD_SECTION_TITLE}
      />
      <NumberCardsComponent
        numberCards={NUMBER_CARD}
        sectionTitle={NUMBER_CARD_SECTION_TITLE}
        sectionText={NUMBER_CARD_SECTION_TEXT}
      />
      <HomeFormComponent />
      <Footer />
    </div>
  );
}

export default Home;
